import React, { useState } from 'react';
import './Footer.css';

import { useNavigate, useLocation } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentYear] = useState(new Date().getFullYear());

  const handleFooterContactClick = (e) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/', { replace: false });
      setTimeout(() => {
        const el = document.getElementById('contact');
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 350);
    } else {
      const el = document.getElementById('contact');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="footer">
      <div className="footer-content">
      <div className="footer-col footer-brand">
        <div className="footer-logo">
          <img src="/logo.webp" alt="Appstoria Logo" className="footer-logo-image" />
          <div className="footer-logo-text">
            <span className="logo-bold">App</span><span className="logo-accent">storia</span>
          </div>
        </div>
        <div className="footer-contact-label">Reach out to us:</div>
        <a className="footer-email" href="mailto:support@appstoria.co">support@appstoria.co</a>
        <div className="footer-address">4220 South Maryland Parkway, 2nd Floor<br/>Las Vegas, Nevada, 89119, USA</div>
        <div className="footer-address">+1 800 8538713</div>
      </div>
      <div className="footer-links-group">
        <div className="footer-col footer-legal">
          <div className="footer-heading">Legal</div>
          <a href="/terms-and-conditions" onClick={e => {e.preventDefault(); navigate('/terms-and-conditions');}}>Terms and Conditions</a>
          <a href="/cookie-policy" onClick={e => {e.preventDefault(); navigate('/cookie-policy');}}>Cookie Policy</a>
          <a href="/privacy-policy" onClick={e => {e.preventDefault(); navigate('/privacy-policy');}}>Privacy Policy</a>
        </div>
        <div className="footer-col footer-partners">
          <div className="footer-heading">Contact Us</div>
          <a href="/#contact" onClick={handleFooterContactClick}>Contact Us</a>

        </div>

        <div className="footer-col footer-store">
          <div className="footer-heading">Products</div>
          <a href="/products" className="footer-link">Products</a>
        </div>
      </div>
    </div>
    <div className="footer-bottom">
      © {currentYear} Appstoria Inc. All rights reserved.
    </div>
    </footer>
  );
}


export default Footer;
